import React from "react";
import { Grid } from "@material-ui/core";
import useStyles from "./styles";
import { usePresettlementExclusionsHook } from "../../PresettlementExclusionsTable/usePresettlementExclusionsHook";
import { DPSearchBar } from "Components/DP";


export function SearchInput() {
  const classes = useStyles();
  const { onSearchTermChange } = usePresettlementExclusionsHook();

  return (
    <Grid item xs={4} container alignItems="center">
      <span>Search</span>
      <DPSearchBar
        submitSearch={onSearchTermChange}
        placeholder="by user ID or name"
        buttonProps={{
          variant: "outlined",
          color: "default",
          className: classes.button,
        }}
        displayDivider
        rootComponentStyles={classes.root}
        inputStyles={classes.input}
      />
    </Grid>
  );
}
